import * as consts from "../consts";
import axios from "axios";

function handleError(exception, message, dispatch) {
  if (process.env.NODE_ENV === "development") {
    console.log("TB-CARDBUILDER:", exception);
  }
  if (message && dispatch) {
    addAlert(
      {
        message: message,
        type: consts.ALERT_TYPE_ERROR,
      },
      dispatch
    );
  }
}

function handleSuccess(response, message, dispatch) {
  if (process.env.NODE_ENV === "development") {
    console.log("TB-CARDBUILDER:", response);
  }
  if (message && dispatch) {
    addAlert(
      {
        message: message,
        type: consts.ALERT_TYPE_SUCCESS,
      },
      dispatch
    );
  }
}

function getHTTPHeaders(getAccessTokenSilently) {
  return new Promise((resolve) => {
    if (getAccessTokenSilently) {
      getAccessTokenSilently()
        .then((token) => {
          let options = token
            ? { headers: { Authorization: `Bearer ${token}` } }
            : {};
          resolve(options);
        })
        .catch(() => {
          resolve({});
        });
    } else {
      resolve({});
    }
  });
}

export function addAlert(alert, dispatch) {
  return new Promise((resolve) => {
    dispatch({
      type: consts.ACTION_ADD_ALERT,
      payload: alert,
    });
    resolve();
  });
}

export function dismissAlert(dispatch) {
  return new Promise((resolve) => {
    dispatch({
      type: consts.ACTION_DISMISS_ALERT,
    });
    resolve();
  });
}

export function saveHearMessage(message, getAccessTokenSilently, dispatch) {
  return new Promise((resolve, reject) => {
    getHTTPHeaders(getAccessTokenSilently).then((options) => {
      options = {
        ...options,
        headers: {
          ...options.headers,
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      };
      axios
        .post(
          `${consts.SERVICE_URL}/User/Hear`,
          JSON.stringify(message),
          options
        )
        .then((response) => {
          resolve();
        })
        .catch((exception) => {
          handleError(exception, `Unable to save message`, dispatch);
          reject(exception);
        });
    });
  });
}

export function getOrder(orderID, getAccessTokenSilently, dispatch) {
  return new Promise((resolve, reject) => {
    getHTTPHeaders(getAccessTokenSilently).then((options) => {
      axios
        .get(`${consts.SERVICE_URL}/Order/orderdetail/${orderID}`, options)
        .then((response) => {
          let order = response.data;
          console.log(order);
          dispatch({
            type: consts.ACTION_INITIALIZE_ORDER,
            payload: order,
          });
          resolve(order);
        })
        .catch((exception) => {
          handleError(exception, `Unable to retrieve order`, dispatch);
          reject(exception);
        });
    });
  });
}
